import { render, staticRenderFns } from "./CheckoutLinkButton.vue?vue&type=template&id=0a58d54d&scoped=true&lang=pug&"
import script from "./CheckoutLinkButton.vue?vue&type=script&lang=js&"
export * from "./CheckoutLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutLinkButton.vue?vue&type=style&index=0&id=0a58d54d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a58d54d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/boyoon/Desktop/Project/kl3/wonderapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a58d54d')) {
      api.createRecord('0a58d54d', component.options)
    } else {
      api.reload('0a58d54d', component.options)
    }
    module.hot.accept("./CheckoutLinkButton.vue?vue&type=template&id=0a58d54d&scoped=true&lang=pug&", function () {
      api.rerender('0a58d54d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/vue-components/buttons/CheckoutLinkButton.vue"
export default component.exports